import { getNumber } from './getNumber'

const findYearByValue = (
  yearly: Record<string, string> | undefined,
  valueToLookFor?: string | number,
): string | null =>
  yearly
    ? Object.entries(yearly).find(([_key, value]) => getNumber(value) === getNumber(valueToLookFor))?.[0] ?? null
    : null

export { findYearByValue }
